module.exports = __webpack_public_path__ + "img/bg3.51f1b3ca.png";